<template>
  <v-container fluid>
    <v-row>
      <v-col sm="12">
        <v-card>
          <v-card-title>
            <v-icon left>fas fa-shield-alt</v-icon>
            PicoShield Inventory
            <v-spacer/>
            <v-text-field
              v-model="search"
              clearable
              prepend-inner-icon="search"
              single-line
              hide-details
            />
          </v-card-title>
          <BatchesTable
            :loading="loading"
            :batches="batches"
            :is-detail="false"
            :search="search"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Batch from "../../models/Batch";
import BatchesTable from "../../components/Batch/BatchesTable";
export default {
  name: "ShippingPicoShieldInventory",
  components: { BatchesTable },
  data() {
    return {
      search: "",
      loading: true
    };
  },
  computed: {
    // Return all batches with ready_to_ship attribute of true
    batches() {
      return Batch.query()
        .where("picoshield", true)
        .with("location")
        .get();
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      Batch
        .$fetchAvailPico()
        .then(() => this.loading = false);
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>
